<template>
  <div
    v-if="showLoadingState < 3"
    key="loadingState"
    class="a-transition-fade m-initial-loading"
  >
    <AtomLoadingPrimary :loading-text="$t('mInitialAccess.message')"/>
  </div>
  <div
    v-else
    key="initialAccess"
    class="a-transition-fade m-card-primary m-initial-access"
  >
    <AtomLogoPrimary/>

    <p v-if="usuarioLicencias.length === 1">
      {{ $t('mInitialAccess.greeting') }}
      <span class="text-color-vidroop-primary">{{ usuarioNombre }}</span>,
      {{ $t('mInitialAccess.availableLicense.first') }}
      {{ $moment.parseZone(usuarioLicencias[0].fecha_alta).format('D MMMM YYYY') }},
      {{ $t('mInitialAccess.availableLicense.second') }}
      <router-link
        class="text-link-hover-billing"
        :to="`/${$t('rPaths.initialSetup')}/${usuarioLicencias[0].id}`"
      >
        <i class="fas fa-link font-size-small"></i>
        {{ $t('mInitialAccess.availableLicense.link') }}.
      </router-link>
    </p>

    <p v-if="usuarioLicencias.length > 1">
      {{ $t('mInitialAccess.greeting') }}
      <span class="text-color-vidroop-primary">{{ usuarioNombre }}</span>,
      {{ $t('mInitialAccess.availableLicenses') }}:
    </p>

    <ul
      v-if="usuarioLicencias.length > 1"
      class="a-list-clean m-initial-access-list margin-zero"
    >
      <li
        v-for="licencia in usuarioLicencias"
        :key="licencia.id"
      >
        <router-link
          class="m-initial-access-list-item m-initial-access-list-item-license"
          :to="`/${$t('rPaths.initialSetup')}/${licencia.id}`"
        >
          <span>
            {{ $t('mInitialAccess.activeLicense') }}
            {{ $moment.parseZone(licencia.fecha_alta).format('D MMMM YYYY') }}
          </span>
          <i class="fas fa-angle-right"></i>
        </router-link>
      </li>
    </ul>

    <p v-if="usuarioLicencias.length >= 1 && usuarioAcademias.length === 1">
       {{ $t('mInitialAccess.accessAcademy.first.select') }}
       {{ usuarioAcademias[0].nombre }}
       {{ $t('mInitialAccess.accessAcademy.first.click') }}
      <a
        href="#"
        class="text-link-hover-billing"
        @click.prevent="$auth.setCurrentAcademy(usuarioAcademias[0])"
      >
        <i class="fas fa-link font-size-small"></i>
        {{ $t('mInitialAccess.accessAcademy.first.link') }}.
      </a>
    </p>

    <p
      v-if="usuarioLicencias.length >= 1 && usuarioAcademias.length > 1"
      class="margin-top-xxlarge"
    >
      {{ $t('mInitialAccess.accessAcademy.second') }}
    </p>

    <p v-if="usuarioLicencias.length === 0 && usuarioAcademias.length > 1">
      {{ $t('mInitialAccess.greeting') }}
      <span class="text-color-vidroop-primary">{{ usuarioNombre }}</span>,
      {{ $t('mInitialAccess.accessAcademy.third') }}
    </p>

    <ul
      v-if="usuarioAcademias.length > 1"
      class="a-list-clean margin-zero m-initial-access-list"
    >
      <li
        v-for="academia in usuarioAcademias"
        :key="academia.id"
      >
        <a
          class="m-initial-access-list-item m-initial-access-list-item-academy"
          href="#"
          @click.prevent="$auth.setCurrentAcademy(academia)"
        >
          <span>{{ academia.nombre }}</span>
          <i class="fas fa-angle-right"></i>
        </a>
      </li>
    </ul>

  </div>
</template>

<script>
import configApp from '@/config'

export default {
  name: 'MoleculeInitialAccess',

  data () {
    return {
      showLoadingState: 0,
      usuario: {},
      usuarioAcademias: [],
      usuarioLicencias: []
    }
  },

  computed: {
    academia () {
      return this.$store.getters.getAcademyData
    },

    usuarioNombre () {
      return this.usuario.vidroop_data &&
        this.usuario.vidroop_data.persona &&
        this.usuario.vidroop_data.persona.razon_social
        ? this.usuario.vidroop_data.persona.razon_social
        : this.usuario.email
    }
  },

  watch: {
    academia () {
      if (this.academia.licencia.activa) {
        this.$router.push({ name: 'home' })
      } else {
        this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.myPayments.subject')}/${this.$t('mEditionMenu.billing.myPayments.children.subscribedPlan.subedition')}`)
      }
    },

    showLoadingState () {
      if (this.showLoadingState === 2 && this.usuarioAcademias.length === 1 && this.usuarioLicencias.length === 1) {
        this.showLoadingState++
      } else if (this.showLoadingState === 2 && (this.usuarioAcademias.length > 1 || this.usuarioLicencias.length > 1)) {
        this.showLoadingState++
      } else if (this.showLoadingState === 2 && this.usuarioAcademias.length === 1 && this.usuarioLicencias.length === 0) {
        this.$auth.setCurrentAcademy(this.usuarioAcademias[0])
      } else if (this.showLoadingState === 2 && this.usuarioAcademias.length === 0 && this.usuarioLicencias.length === 1) {
        this.$router.push(`/${this.$t('rPaths.initialSetup')}/${this.usuarioLicencias[0].id}`)
      } else if (this.showLoadingState === 2 && this.usuarioAcademias.length === 0 && this.usuarioLicencias.length === 0) {
        // TODO: log error
        this.$auth.logout()
      }
    }
  },

  created () {
    this.usuario = this.$store.getters.getUserData
    this.readAcademias()
    this.readLicenciasUsuario()
  },

  methods: {
    readAcademias () {
      this.$services.read('academia', 'readAcademias', {}, [], this.$auth.filter)
        .then(response => {
          let academias = response.data
          academias.forEach(academia => {
            if (academia.estado && (academia.licencia || academia.id === configApp.vidroopAcademyId)) {
              this.usuarioAcademias.push(academia)
            }
          })
          this.usuarioAcademias.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1)
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readLicenciasUsuario () {
      this.$services.read('licencia', 'readLicenciasUsuario')
        .then(response => {
          let licencias = response.data
          licencias.forEach(licencia => {
            if (licencia.activa && licencia.academia === undefined) {
              this.usuarioLicencias.push(licencia)
            }
          })
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    }
  }
}
</script>
